import { useExperiments } from '@wix/fe-essentials-standalone';

import { EXPERIMENTS } from '../constants';

const useIsKbServiceEnabled = () => {
  const { experiments } = useExperiments({ suspense: false, readOnly: true });
  return experiments.enabled(EXPERIMENTS.SPECS.ARTICLE_FROM_KB_SERVICE);
};

export default useIsKbServiceEnabled;
